import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'
import t from '~/scopes/campaign/data/metals/zirconium.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['usgsMcs2025', 'gomez2023'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['usgsMcs2025', 'scrreenZirconium2025'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['ieaMineralsExplorer', 'scrreenZirconium2025'],
  },
  // Every environmental and human sub-section reads `n/a`: both read-mores
  // are empty and the sheet gives only the summaries.
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: [
          'ademe2024',
          'pblEnvironmental2024',
          'scrreenZirconium2025',
        ],
      },
      blocks: [],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: [
          'ademe2024',
          'pblEnvironmental2024',
          'scrreenZirconium2025',
        ],
      },
      blocks: [],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'scrreenZirconium2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['scrreenZirconium2025'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['ieaGcmo2025', 'scrreenZirconium2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['scrreenZirconium2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['usgsMcs2025'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: [
          'ieaGcmo2025',
          'ieaMineralsExplorer',
          'scrreenZirconium2025',
        ],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['scrreenZirconium2025'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['unepRecyclingRates2011', 'scrreenZirconium2025'],
      },
    ],
  },
  // `*` on the four scores it names; recycling carries none.
  footnotes: [
    {
      body: [
        {
          text: t.footnote1Text1,
          sourceRefs: ['ademe2024'],
        },
      ],
      slots: [
        'environmentalScore',
        'humanScore',
        'geopoliticalScore',
        'supplyRiskScore',
      ],
    },
  ],
  mine0Region: t.mine0Region,
  mine1Region: t.mine1Region,
  mine2Region: t.mine2Region,
  mine3Region: t.mine3Region,
  mine4Region: t.mine4Region,
  mine5Region: t.mine5Region,
  mine6Region: t.mine6Region,
  mine7Region: t.mine7Region,
} as const
